//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class SendNotificationVm {
    userIdentifiers : string[];
    title : string;
    message : string;

    constructor()
    {
    	            this.userIdentifiers = [];
                this.title = "" ;
                this.message = "" ;
        }
}

export class SimpleEntity {
    identifier : string;

    constructor()
    {
    	            this.identifier = "" ;
        }
}

export class Notification extends SimpleEntity {
    receiverIdentifier : string;
    text : string;
    title : string;
    notificationType : string;
    readOn : string ;
    createdOn : string ;
    navigateTo : string;

    constructor()
    {
    	        super();
		            this.receiverIdentifier = "" ;
                this.text = "" ;
                this.title = "" ;
                this.notificationType = "" ;
                this.readOn = null;
                this.createdOn = null;
                this.navigateTo = "" ;
        }
}

export class AgencyVM {
    identifier : string;
    modifiedOn : string ;
    companyName : string;
    vatNumber : string;
    pecEmail : string;
    sdiCode : string;
    website : string;
    numEmployees : string;
    category : string;
    phoneNumber : string;
    registeredOfficeAddress : string;
    operatingOfficeAddress : string;
    discount : number;

    constructor()
    {
    	            this.identifier = "" ;
                this.modifiedOn = null;
                this.companyName = "" ;
                this.vatNumber = "" ;
                this.pecEmail = "" ;
                this.sdiCode = "" ;
                this.website = "" ;
                this.numEmployees = "" ;
                this.category = "" ;
                this.phoneNumber = "" ;
                this.registeredOfficeAddress = "" ;
                this.operatingOfficeAddress = "" ;
                this.discount = null ;
        }
}

export class AgentVM {
    identifier : string;
    email : string;
    preferredCulture : string;
    name : string;
    surname : string;
    completeName : string;
    workingPosition : string;
    department : string;
    phoneNumber : string;
    mainAgent : boolean;
    extensionNumber : string;
    approvedBy : string;
    approvedOn : string ;
    agency : TextIdentifier;

    constructor()
    {
    	            this.identifier = "" ;
                this.email = "" ;
                this.preferredCulture = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.completeName = "" ;
                this.workingPosition = "" ;
                this.department = "" ;
                this.phoneNumber = "" ;
                this.mainAgent = false ;
                this.extensionNumber = "" ;
                this.approvedBy = "" ;
                this.approvedOn = null;
                this.agency = new TextIdentifier();
        }
}

export class TextIdentifier {
    text : string;
    identifier : string;

    constructor()
    {
    	            this.text = "" ;
                this.identifier = "" ;
        }
}

export class LoggedUserVM {
    identifier : string;
    email : string;
    completeName : string;
    thumbnailUrl : string;
    averageRating : number;
    role : string;
    token : string;
    fcmID : string;
    preferredCulture : string;
    backdoor : boolean;

    constructor()
    {
    	            this.identifier = "" ;
                this.email = "" ;
                this.completeName = "" ;
                this.thumbnailUrl = "" ;
                this.averageRating = null ;
                this.role = "" ;
                this.token = "" ;
                this.fcmID = "" ;
                this.preferredCulture = "" ;
                this.backdoor = false ;
        }
}

export class PricePeriodAvailabilityVm {
    reservedPeriods : PeriodStatus[];
    maxPrice : number;
    minPrice : number;
    recommendedPrice : number;
    locationFee : number;
    gmcFee : number;

    constructor()
    {
    	            this.reservedPeriods = [];
                this.maxPrice = null ;
                this.minPrice = null ;
                this.recommendedPrice = null ;
                this.locationFee = null ;
                this.gmcFee = null ;
        }
}

export class PeriodStatus {
    period : DatePeriod;
    status : string;

    constructor()
    {
    	            this.period = new DatePeriod();
                this.status = "" ;
        }
}

export class DatePeriod {
    start : string ;
    end : string ;
    periodInterval : string;

    constructor()
    {
    	            this.start = null;
                this.end = null;
                this.periodInterval = "" ;
        }
}

export class AvailabilityListVM {
    identifier : string;
    period : DatePeriod;
    dailyPrice : number;
    locationCount : number;
    active : boolean;
    parkingoReservationID : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.period = new DatePeriod();
                this.dailyPrice = null ;
                this.locationCount = null ;
                this.active = false ;
                this.parkingoReservationID = "" ;
        }
}

export class ReservationResumeBox {
    reservationIdentifier : string;
    reservationNumber : string;
    otherPersonCompleteName : string;
    vehicle : BaseVehicle;
    location : TextIdentifier;
    period : DatePeriod;
    status : number;
    changedOn : string ;
    isApi : boolean;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.reservationNumber = "" ;
                this.otherPersonCompleteName = "" ;
                this.vehicle = new BaseVehicle();
                this.location = new TextIdentifier();
                this.period = new DatePeriod();
                this.status = null ;
                this.changedOn = null;
                this.isApi = false ;
        }
}

export class BaseVehicle {
    model : BaseVehicleModel;
    thumbnailUrl : string;
    powerCv : number;
    seats : number;
    fuel : string;
    transmission : string;
    feedback : number;
    licensePlate : string;
    minDriverAge : number;
    owner : ThumbnailBaseUser;
    baseDailyPrice : number;
    identifier : string;
    isProfessional : boolean;

    constructor()
    {
    	            this.model = new BaseVehicleModel();
                this.thumbnailUrl = "" ;
                this.powerCv = null ;
                this.seats = null ;
                this.fuel = "" ;
                this.transmission = "" ;
                this.feedback = null ;
                this.licensePlate = "" ;
                this.minDriverAge = null ;
                this.owner = new ThumbnailBaseUser();
                this.baseDailyPrice = null ;
                this.identifier = "" ;
                this.isProfessional = false ;
        }
}

export class BaseVehicleModel {
    brand : TextIdentifier;
    model : Model;

    constructor()
    {
    	            this.brand = new TextIdentifier();
                this.model = new Model();
        }
}

export class Model {
    modelIdentifier : string;
    modelName : string;
    modelYear : string;
    vehicleCategory : string;
    disabledOn : string ;
    disabledBy : ThumbnailBaseUser;

    constructor()
    {
    	            this.modelIdentifier = "" ;
                this.modelName = "" ;
                this.modelYear = "" ;
                this.vehicleCategory = "" ;
                this.disabledOn = null;
                this.disabledBy = new ThumbnailBaseUser();
        }
}

export class ThumbnailBaseUser {
    identifier : string;
    role : string;
    completeName : string;
    thumbnailUrl : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.role = "" ;
                this.completeName = "" ;
                this.thumbnailUrl = "" ;
        }
}

export class LocationResultVM {
    locationIdentifier : string;
    numberVehicle : number;
    latitude : number;
    longitude : number;

    constructor()
    {
    	            this.locationIdentifier = "" ;
                this.numberVehicle = null ;
                this.latitude = null ;
                this.longitude = null ;
        }
}

export class SearchBaseFilterVM {
    period : DatePeriodVM;
    maxDailyPrice : number;
    vehicleCategory : string[];
    vehicleTrasmission : string;
    vehicleFuel : string;

    constructor()
    {
    	            this.period = new DatePeriodVM();
                this.maxDailyPrice = null ;
                this.vehicleCategory = [];
                this.vehicleTrasmission = "" ;
                this.vehicleFuel = "" ;
        }
}

export class SearchLocationFilterVM extends SearchBaseFilterVM {
    distance : DistanceSearchVm;
    provinceName : string;
    locationAreaPickup : string;
    locationAreaDropOff : string;
    isTest : boolean;
    excludedCategories : string[];

    constructor()
    {
    	        super();
		            this.distance = new DistanceSearchVm();
                this.provinceName = "" ;
                this.locationAreaPickup = "" ;
                this.locationAreaDropOff = "" ;
                this.isTest = false ;
                this.excludedCategories = [];
        }
}

export class DistanceSearchVm {
    latitude : number;
    longitude : number;
    distanceMeters : number;

    constructor()
    {
    	            this.latitude = null ;
                this.longitude = null ;
                this.distanceMeters = null ;
        }
}

export class DatePeriodVM {
    start : string ;
    end : string ;
    solarDays : number;

    constructor()
    {
    	            this.start = null;
                this.end = null;
                this.solarDays = null ;
        }
}

export class VehiclesInLocationSearchResultVM {
    location : LocationDetailVM;
    vehicles : VehiclesFilteredOnLocationVM[];

    constructor()
    {
    	            this.location = new LocationDetailVM();
                this.vehicles = [];
        }
}

export class LocationListVM {
    identifier : string;
    address : Address;
    contact : ContactData;
    title : string;
    locationManagerName : string;
    disabledOn : string ;

    constructor()
    {
    	            this.identifier = "" ;
                this.address = new Address();
                this.contact = new ContactData();
                this.title = "" ;
                this.locationManagerName = "" ;
                this.disabledOn = null;
        }
}

export class LocationDetailVM extends LocationListVM {
    thumbnailUrl : string;

    constructor()
    {
    	        super();
		            this.thumbnailUrl = "" ;
        }
}

export class Address {
    name : string;
    typedAddress : string;
    streetNumber : string;
    route : string;
    locality : string;
    province : string;
    region : string;
    country : string;
    countryCode : string;
    postalCode : string;
    latitude : number;
    longitude : number;
    completeAddress : string;

    constructor()
    {
    	            this.name = "" ;
                this.typedAddress = "" ;
                this.streetNumber = "" ;
                this.route = "" ;
                this.locality = "" ;
                this.province = "" ;
                this.region = "" ;
                this.country = "" ;
                this.countryCode = "" ;
                this.postalCode = "" ;
                this.latitude = null ;
                this.longitude = null ;
                this.completeAddress = "" ;
        }
}

export class ContactData {
    phoneNumber : string;
    phoneNumberValidationCode : string;
    phoneNumberValidatedOn : string ;
    emailAddress : string;

    constructor()
    {
    	            this.phoneNumber = "" ;
                this.phoneNumberValidationCode = "" ;
                this.phoneNumberValidatedOn = null;
                this.emailAddress = "" ;
        }
}

export class BaseVehicleListVM {
    vehicleIdentifier : string;
    modelName : string;
    brandName : string;
    approvedOn : string ;
    refusedOn : string ;
    refusedFor : string;

    constructor()
    {
    	            this.vehicleIdentifier = "" ;
                this.modelName = "" ;
                this.brandName = "" ;
                this.approvedOn = null;
                this.refusedOn = null;
                this.refusedFor = "" ;
        }
}

export class VehicleListVM extends BaseVehicleListVM {
    plate : string;
    shares : number;
    earnings : number;
    thumbnailUrl : string;
    disabled : boolean;
    completeOwnerName : string;

    constructor()
    {
    	        super();
		            this.plate = "" ;
                this.shares = null ;
                this.earnings = null ;
                this.thumbnailUrl = "" ;
                this.disabled = false ;
                this.completeOwnerName = "" ;
        }
}

export class VehiclesFilteredOnLocationVM extends VehicleListVM {
    averageFeedback : number;
    category : string;
    ownerIdentifier : string;
    provider : string;
    licensePlate : string;
    dailyPrice : number;
    discountDailyPrice : number;
    totalDiscount : number;
    discount : number;
    rentPrice : number;
    totalPrice : number;
    pickupLocation : TextIdentifier;
    dropoffLocation : TextIdentifier;
    images : string[];
    availabilityIdentifier : string;
    seats : number;
    fuel : string;
    transmission : string;
    features : TextIconIdentifier[];
    useConditions : TextIconIdentifier[];
    minDriverAge : number;
    description : string;
    isApi : boolean;
    sippCode : string;
    groupCode : string;
    providerVehicleData : ApiProviderVehicleData;
    extras : ApiVehicleExtra[];
    slugHelper : SlugHelper;

    constructor()
    {
    	        super();
		            this.averageFeedback = null ;
                this.category = "" ;
                this.ownerIdentifier = "" ;
                this.provider = "" ;
                this.licensePlate = "" ;
                this.dailyPrice = null ;
                this.discountDailyPrice = null ;
                this.totalDiscount = null ;
                this.discount = null ;
                this.rentPrice = null ;
                this.totalPrice = null ;
                this.pickupLocation = new TextIdentifier();
                this.dropoffLocation = new TextIdentifier();
                this.images = [];
                this.availabilityIdentifier = "" ;
                this.seats = null ;
                this.fuel = "" ;
                this.transmission = "" ;
                this.features = [];
                this.useConditions = [];
                this.minDriverAge = null ;
                this.description = "" ;
                this.isApi = false ;
                this.sippCode = "" ;
                this.groupCode = "" ;
                this.providerVehicleData = new ApiProviderVehicleData();
                this.extras = [];
                this.slugHelper = new SlugHelper();
        }
}

export class TextIconIdentifier {
    identifier : string;
    text : RS24LocalizedEntity;
    icon : AWSS3Attachment;

    constructor()
    {
    	            this.identifier = "" ;
                this.text = new RS24LocalizedEntity();
                this.icon = new AWSS3Attachment();
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor()
    {
    	            this.values = {};
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor()
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class RS24LocalizedEntity extends LocalizedEntity {

    constructor()
    {
    	        super();
		    }
}

export abstract class BaseAttachment {
    fileIdentifier : string;
    fileName : string;
    mimeType : string;
    lastModifiedOn : string ;
    subDir : string;

    constructor()
    {
    	            this.fileIdentifier = "" ;
                this.fileName = "" ;
                this.mimeType = "" ;
                this.lastModifiedOn = null;
                this.subDir = "" ;
        }
}

export class AWSS3Attachment extends BaseAttachment {
    region : string;
    bucket : string;

    constructor()
    {
    	        super();
		            this.region = "" ;
                this.bucket = "" ;
        }
}

export class ApiProviderVehicleData {
    pricelistId : string;
    modelId : string;

    constructor()
    {
    	            this.pricelistId = "" ;
                this.modelId = "" ;
        }
}

export class ApiVehicleExtra {
    grossSingleAmount : number;
    grossTotalAmount : number;
    singleAmount : number;
    totalAmount : number;
    mapName : string;
    name : string;
    description : string;
    icon : string;
    rateType : string;
    maxQty : number;
    maxDays : number;
    requestedQty : number;
    duration : number;

    constructor()
    {
    	            this.grossSingleAmount = null ;
                this.grossTotalAmount = null ;
                this.singleAmount = null ;
                this.totalAmount = null ;
                this.mapName = "" ;
                this.name = "" ;
                this.description = "" ;
                this.icon = "" ;
                this.rateType = "" ;
                this.maxQty = null ;
                this.maxDays = null ;
                this.requestedQty = null ;
                this.duration = null ;
        }
}

export class SlugHelper {

    constructor()
    {
    	    }
}

export class SearchCarFilterVM extends SearchBaseFilterVM {
    locationIdentifier : string;

    constructor()
    {
    	        super();
		            this.locationIdentifier = "" ;
        }
}

export class UpdateAvailabilityVM {
    identifier : string;
    vehicleIdentifier : string;
    datePeriod : DatePeriodVM;
    simplePrice : SimplePrice;
    locations : AddressTextIdentifier[];
    parkingoData : ParkingoReservationData;
    priceVariations : PriceRule[];
    parkingoReservationID : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.vehicleIdentifier = "" ;
                this.datePeriod = new DatePeriodVM();
                this.simplePrice = new SimplePrice();
                this.locations = [];
                this.parkingoData = new ParkingoReservationData();
                this.priceVariations = [];
                this.parkingoReservationID = "" ;
        }
}

export class SimplePrice {
    basePrice : number;

    constructor()
    {
    	            this.basePrice = null ;
        }
}

export class AddressTextIdentifier extends TextIdentifier {
    address : Address;

    constructor()
    {
    	        super();
		            this.address = new Address();
        }
}

export class ParkingoReservationData {
    bookingNumber : string;
    days : number;
    totalBookingPrice : number;
    bookingPrice : number;
    parkName : string;
    payed : string;
    address : string;
    checkIn : string ;
    checkOut : string ;
    brand : string;
    discount : number;

    constructor()
    {
    	            this.bookingNumber = "" ;
                this.days = null ;
                this.totalBookingPrice = null ;
                this.bookingPrice = null ;
                this.parkName = "" ;
                this.payed = "" ;
                this.address = "" ;
                this.checkIn = null;
                this.checkOut = null;
                this.brand = "" ;
                this.discount = null ;
        }
}

export class BasePriceRule {
    condition : DatePeriodCondition;

    constructor()
    {
    	            this.condition = new DatePeriodCondition();
        }
}

export class PriceRule extends BasePriceRule {
    tag : PriceTag;

    constructor()
    {
    	        super();
		            this.tag = new PriceTag();
        }
}

export class PriceTag {
    text : RS24LocalizedEntity;
    priceVariation : PriceVariation;

    constructor()
    {
    	            this.text = new RS24LocalizedEntity();
                this.priceVariation = new PriceVariation();
        }
}

export class PriceVariation {
    percentageValue : number;
    absoluteValue : number;

    constructor()
    {
    	            this.percentageValue = null ;
                this.absoluteValue = null ;
        }
}

export class DatePeriodCondition {
    period : DatePeriod;

    constructor()
    {
    	            this.period = new DatePeriod();
        }
}

export class UpdateDatePeriodVM {
    identifier : string;
    datePeriod : DatePeriod;

    constructor()
    {
    	            this.identifier = "" ;
                this.datePeriod = new DatePeriod();
        }
}

export class CreateAvailabilityVm extends UpdateDatePeriodVM {
    vehicleIdentifier : string;

    constructor()
    {
    	        super();
		            this.vehicleIdentifier = "" ;
        }
}

export class UpdateSimplePriceVM {
    identifier : string;
    simplePrice : SimplePrice;

    constructor()
    {
    	            this.identifier = "" ;
                this.simplePrice = new SimplePrice();
        }
}

export class ChangePriceVariationsVM {
    availabilityIdentifier : string;
    priceVariations : PriceVariationsVM[];

    constructor()
    {
    	            this.availabilityIdentifier = "" ;
                this.priceVariations = [];
        }
}

export class PriceVariationsVM {
    priceConditionVM : SaveConfigurationPriceConditionVM;
    priceTagVM : SaveConfigurationPriceTagVM;

    constructor()
    {
    	            this.priceConditionVM = new SaveConfigurationPriceConditionVM();
                this.priceTagVM = new SaveConfigurationPriceTagVM();
        }
}

export class SaveConfigurationPriceConditionVM {
    identifier : string;
    title : string;
    period : DatePeriodVM;
    location : string;
    vehicleCategory : string;
    rentDuration : string;
    owner : string;
    baseCondition : DatePeriodCondition;
    extendedCondition : ExtendedConditionVM;

    constructor()
    {
    	            this.identifier = "" ;
                this.title = "" ;
                this.period = new DatePeriodVM();
                this.location = "" ;
                this.vehicleCategory = "" ;
                this.rentDuration = "" ;
                this.owner = "" ;
                this.baseCondition = new DatePeriodCondition();
                this.extendedCondition = new ExtendedConditionVM();
        }
}

export class ExtendedConditionVM {
    period : DatePeriod;
    vehicleCategory : string;
    rentDuration : ComparableTimeSpanVM;
    location : TextIdentifier;
    owner : TextIdentifier;

    constructor()
    {
    	            this.period = new DatePeriod();
                this.vehicleCategory = "" ;
                this.rentDuration = new ComparableTimeSpanVM();
                this.location = new TextIdentifier();
                this.owner = new TextIdentifier();
        }
}

export class ComparableTimeSpanVM {
    time : number;
    comparison : ComparisonOperator;

    constructor()
    {
    	            this.time = null ;
                this.comparison = null;
        }
}

export enum ComparisonOperator {
    Less = 0,
    Equal = 1,
    Greater = 2,
}

export class SaveConfigurationPriceTagVM {
    identifier : string;
    value : RS24LocalizedEntity;
    priceVariation : PriceVariation;
    floorPriceVariation : FloorPriceVariation;

    constructor()
    {
    	            this.identifier = "" ;
                this.value = new RS24LocalizedEntity();
                this.priceVariation = new PriceVariation();
                this.floorPriceVariation = new FloorPriceVariation();
        }
}

export class FloorPriceVariation extends PriceVariation {
    floorValue : number;

    constructor()
    {
    	        super();
		            this.floorValue = null ;
        }
}

export class UpdateLocationsVM {
    identifier : string;
    locations : AddressTextIdentifier[];

    constructor()
    {
    	            this.identifier = "" ;
                this.locations = [];
        }
}

export class PriceFilterVM {
    min : number;
    max : number;

    constructor()
    {
    	            this.min = null ;
                this.max = null ;
        }
}

export class BalanceDashboardVm {
    newLocationWithdrawRequestCount : number;
    newOwnerWithdrawRequestCount : number;
    currentYearGmcFeesAmount : number;
    currentYearAmount : number;

    constructor()
    {
    	            this.newLocationWithdrawRequestCount = null ;
                this.newOwnerWithdrawRequestCount = null ;
                this.currentYearGmcFeesAmount = null ;
                this.currentYearAmount = null ;
        }
}

export class UserStatementsVm {
    userIdentifier : string;
    statementsDetail : StatementDetailVm[];
    withdrawableAmount : number;
    totalBalanceAmount : number;
    existsPendingRequest : boolean;
    pendingRequestDate : string ;
    iban : string;

    constructor()
    {
    	            this.userIdentifier = "" ;
                this.statementsDetail = [];
                this.withdrawableAmount = null ;
                this.totalBalanceAmount = null ;
                this.existsPendingRequest = false ;
                this.pendingRequestDate = null;
                this.iban = "" ;
        }
}

export class StatementDetailVm {
    actionText : string;
    amount : number;
    createdOn : string ;
    relatedCode : string;
    relatedIdentifier : string;

    constructor()
    {
    	            this.actionText = "" ;
                this.amount = null ;
                this.createdOn = null;
                this.relatedCode = "" ;
                this.relatedIdentifier = "" ;
        }
}

export class ForceBalanceMovementVm {
    balanceOwnerIdentifier : string;
    amount : number;
    note : string;
    attachment : string;
    action : string;

    constructor()
    {
    	            this.balanceOwnerIdentifier = "" ;
                this.amount = null ;
                this.note = "" ;
                this.attachment = "" ;
                this.action = "" ;
        }
}

export class ConfigurationServiceItemVM {
    identifier : string;
    publicUrl : string;
    text : RS24LocalizedEntity;

    constructor()
    {
    	            this.identifier = "" ;
                this.publicUrl = "" ;
                this.text = new RS24LocalizedEntity();
        }
}

export class SaveConfigServiceItemVM {
    identifier : string;
    key : string;
    values : KeyValuePairOfStringAndString[];

    constructor()
    {
    	            this.identifier = "" ;
                this.key = "" ;
                this.values = [];
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor()
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export class ConfigurationAccessoryItemVM {
    identifier : string;
    publicUrl : string;
    code : string;
    text : RS24LocalizedEntity;

    constructor()
    {
    	            this.identifier = "" ;
                this.publicUrl = "" ;
                this.code = "" ;
                this.text = new RS24LocalizedEntity();
        }
}

export class SaveConfigAccessoryItemVM {
    identifier : string;
    code : string;
    key : string;
    values : KeyValuePairOfStringAndString[];

    constructor()
    {
    	            this.identifier = "" ;
                this.code = "" ;
                this.key = "" ;
                this.values = [];
        }
}

export class TextImageIdItemVM {
    identifier : string;
    publicUrl : string;
    text : RS24LocalizedEntity;
    newFile : string;
    fileName : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.publicUrl = "" ;
                this.text = new RS24LocalizedEntity();
                this.newFile = "" ;
                this.fileName = "" ;
        }
}

export class ConfigurationBasePriceVM {
    identifier : string;
    vehicleCategory : string;
    slope : number;
    originVariation : number;

    constructor()
    {
    	            this.identifier = "" ;
                this.vehicleCategory = "" ;
                this.slope = null ;
                this.originVariation = null ;
        }
}

export class PagedResponseOfSaveConfigurationPriceConditionVM {
    items : SaveConfigurationPriceConditionVM[];
    totalItemsCount : number;

    constructor()
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class PagedResponseOfConfigurationPriceRuleVM {
    items : ConfigurationPriceRuleVM[];
    totalItemsCount : number;

    constructor()
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class ConfigurationPriceRule extends SimpleEntity {
    createdOn : string ;
    disabledOn : string ;
    disabledBy : ThumbnailBaseUser;
    defaultPriceRule : PriceRule;
    identifierTag : string;
    identifierCondition : string;
    creator : ThumbnailBaseUser;

    constructor()
    {
    	        super();
		            this.createdOn = null;
                this.disabledOn = null;
                this.disabledBy = new ThumbnailBaseUser();
                this.defaultPriceRule = new PriceRule();
                this.identifierTag = "" ;
                this.identifierCondition = "" ;
                this.creator = new ThumbnailBaseUser();
        }
}

export class ConfigurationPriceRuleVM extends ConfigurationPriceRule {
    text : string;
    period : DatePeriodVM;
    location : string;
    vehicleCategory : string;
    rentDuration : string;
    owner : string;
    tagValue : string;

    constructor()
    {
    	        super();
		            this.text = "" ;
                this.period = new DatePeriodVM();
                this.location = "" ;
                this.vehicleCategory = "" ;
                this.rentDuration = "" ;
                this.owner = "" ;
                this.tagValue = "" ;
        }
}

export class ConfigurationPointOfInterestVM {
    identifier : string;
    publicUrl : string;
    text : RS24LocalizedEntity;
    slug : RS24LocalizedEntity;

    constructor()
    {
    	            this.identifier = "" ;
                this.publicUrl = "" ;
                this.text = new RS24LocalizedEntity();
                this.slug = new RS24LocalizedEntity();
        }
}

export class SaveConfigPointOfInterestVM {
    identifier : string;
    text : SaveConfigPointOfInterestItemVM;
    slug : SaveConfigPointOfInterestItemVM;

    constructor()
    {
    	            this.identifier = "" ;
                this.text = new SaveConfigPointOfInterestItemVM();
                this.slug = new SaveConfigPointOfInterestItemVM();
        }
}

export class SaveConfigPointOfInterestItemVM {
    identifier : string;
    key : string;
    values : KeyValuePairOfStringAndString[];

    constructor()
    {
    	            this.identifier = "" ;
                this.key = "" ;
                this.values = [];
        }
}

export class SippCodeGroupMapping {
    sippCode : string;
    groupCode : string;

    constructor()
    {
    	            this.sippCode = "" ;
                this.groupCode = "" ;
        }
}

export class BuyableCouponVM {
    amount : number;
    bonusAmount : number;
    bonusPercentage : number;

    constructor()
    {
    	            this.amount = null ;
                this.bonusAmount = null ;
                this.bonusPercentage = null ;
        }
}

export class CouponResumeVM {
    code : string;
    completeName : string;
    amount : number;
    bonusAmount : number;
    totalAmount : number;
    bonusPercentage : number;
    activatedOn : string ;
    bonusExpiresOn : string ;
    bonusDisabledOn : string ;

    constructor()
    {
    	            this.code = "" ;
                this.completeName = "" ;
                this.amount = null ;
                this.bonusAmount = null ;
                this.totalAmount = null ;
                this.bonusPercentage = null ;
                this.activatedOn = null;
                this.bonusExpiresOn = null;
                this.bonusDisabledOn = null;
        }
}

export class BaseCredential {
    email : string;
    password : string;

    constructor()
    {
    	            this.email = "" ;
                this.password = "" ;
        }
}

export class LanguageCredential extends BaseCredential {
    preferredCulture : string;

    constructor()
    {
    	        super();
		            this.preferredCulture = "" ;
        }
}

export class CustomerRegistrationVm extends LanguageCredential {
    name : string;
    surname : string;

    constructor()
    {
    	        super();
		            this.name = "" ;
                this.surname = "" ;
        }
}

export class CustomerVM {
    identifier : string;
    name : string;
    surname : string;
    email : string;
    phoneNumber : string;
    phoneNumberValidatedOn : string ;
    birthDate : string ;
    birthPlace : string;
    birthProvince : string;
    fiscalCode : string;
    frontLicense : string;
    backLicense : string;
    frontID : string;
    backID : string;
    documentExpiresOn : string ;
    documentNumber : string;
    settings : Settings;
    releasedBy : string;
    releasedOn : string ;
    refusedOn : string ;
    approvedOn : string ;
    disabledOn : string ;
    disabledBy : ThumbnailBaseUser;
    licenseNumber : string;
    address : Address;
    expiresOn : string ;
    thumbnailUrl : string;
    country : string;
    countryOfResidence : string;
    profileImageName : string;
    frontIdImageName : string;
    backIdImageName : string;
    frontLicImageName : string;
    backLicImageName : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.phoneNumber = "" ;
                this.phoneNumberValidatedOn = null;
                this.birthDate = null;
                this.birthPlace = "" ;
                this.birthProvince = "" ;
                this.fiscalCode = "" ;
                this.frontLicense = "" ;
                this.backLicense = "" ;
                this.frontID = "" ;
                this.backID = "" ;
                this.documentExpiresOn = null;
                this.documentNumber = "" ;
                this.settings = new Settings();
                this.releasedBy = "" ;
                this.releasedOn = null;
                this.refusedOn = null;
                this.approvedOn = null;
                this.disabledOn = null;
                this.disabledBy = new ThumbnailBaseUser();
                this.licenseNumber = "" ;
                this.address = new Address();
                this.expiresOn = null;
                this.thumbnailUrl = "" ;
                this.country = "" ;
                this.countryOfResidence = "" ;
                this.profileImageName = "" ;
                this.frontIdImageName = "" ;
                this.backIdImageName = "" ;
                this.frontLicImageName = "" ;
                this.backLicImageName = "" ;
        }
}

export class Settings {
    tripNotification : TrasmissionMode;
    commercialNotification : TrasmissionMode;
    updatedOn : string ;

    constructor()
    {
    	            this.tripNotification = new TrasmissionMode();
                this.commercialNotification = new TrasmissionMode();
                this.updatedOn = null;
        }
}

export class TrasmissionMode {
    sms : boolean;
    email : boolean;

    constructor()
    {
    	            this.sms = false ;
                this.email = false ;
        }
}

export class CustomerBankDataVm {
    customerIdentifier : string;
    iban : string;

    constructor()
    {
    	            this.customerIdentifier = "" ;
                this.iban = "" ;
        }
}

export class CustomerBalanceVM {
    identifier : string;
    name : string;
    surname : string;
    email : string;
    phoneNumber : string;
    country : string;
    balance : number;

    constructor()
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.phoneNumber = "" ;
                this.country = "" ;
                this.balance = null ;
        }
}

export class FiscalData extends SimpleEntity {
    label : string;
    taxID : string;
    subjectType : string;
    vatNumber : string;
    fiscalAddress : Address;
    pecEmail : string;
    sdiCode : string;
    companyName : string;
    personName : string;

    constructor()
    {
    	        super();
		            this.label = "" ;
                this.taxID = "" ;
                this.subjectType = "" ;
                this.vatNumber = "" ;
                this.fiscalAddress = new Address();
                this.pecEmail = "" ;
                this.sdiCode = "" ;
                this.companyName = "" ;
                this.personName = "" ;
        }
}

export class FiscalDataVM extends FiscalData {
    completeAddress : string;
    targetIdentifier : string;

    constructor()
    {
    	        super();
		            this.completeAddress = "" ;
                this.targetIdentifier = "" ;
        }
}

export class CustomerNews {
    message : string;
    id : string;

    constructor()
    {
    	            this.message = "" ;
                this.id = "" ;
        }
}

export class LeadVM extends CustomerRegistrationVm {
    numberOfReservation : number;
    insertedOn : string ;

    constructor()
    {
    	        super();
		            this.numberOfReservation = null ;
                this.insertedOn = null;
        }
}

export class BaseEntity extends SimpleEntity {
    createdOn : string ;
    modifiedOn : string ;

    constructor()
    {
    	        super();
		            this.createdOn = null;
                this.modifiedOn = null;
        }
}

export class User extends BaseEntity {
    login : LoginData;
    contact : ContactData;
    license : License;
    settings : Settings;
    fcmId : string;
    age : number;
    role : string;
    preferredCulture : string;
    personalData : PersonalData;
    address : Address;
    completeName : string;
    thumbnailUrl : string;
    thumbnailAttachment : AWSS3Attachment;
    disabledBy : ThumbnailBaseUser;
    disabledOn : string ;

    constructor()
    {
    	        super();
		            this.login = new LoginData();
                this.contact = new ContactData();
                this.license = new License();
                this.settings = new Settings();
                this.fcmId = "" ;
                this.age = null ;
                this.role = "" ;
                this.preferredCulture = "" ;
                this.personalData = new PersonalData();
                this.address = new Address();
                this.completeName = "" ;
                this.thumbnailUrl = "" ;
                this.thumbnailAttachment = new AWSS3Attachment();
                this.disabledBy = new ThumbnailBaseUser();
                this.disabledOn = null;
        }
}

export class LoginData extends BaseCredential {
    resetPassword : string;
    externalProviders : KeyValuePairOfStringAndString[];

    constructor()
    {
    	        super();
		            this.resetPassword = "" ;
                this.externalProviders = [];
        }
}

export class License {
    frontImage : AWSS3Attachment;
    backImage : AWSS3Attachment;
    documentNumber : string;
    releasedBy : string;
    releasedOn : string ;
    expiresOn : string ;
    country : string;

    constructor()
    {
    	            this.frontImage = new AWSS3Attachment();
                this.backImage = new AWSS3Attachment();
                this.documentNumber = "" ;
                this.releasedBy = "" ;
                this.releasedOn = null;
                this.expiresOn = null;
                this.country = "" ;
        }
}

export class PersonalData {
    name : string;
    surname : string;
    birthDate : string ;
    birthPlace : string;
    birthProvince : string;
    birthCountry : string;
    fiscalCode : string;
    frontImage : AWSS3Attachment;
    backImage : AWSS3Attachment;
    documentExpiresOn : string ;
    documentNumber : string;

    constructor()
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.birthDate = null;
                this.birthPlace = "" ;
                this.birthProvince = "" ;
                this.birthCountry = "" ;
                this.fiscalCode = "" ;
                this.frontImage = new AWSS3Attachment();
                this.backImage = new AWSS3Attachment();
                this.documentExpiresOn = null;
                this.documentNumber = "" ;
        }
}

export class CustomerCompleteProfileVm {
    identifier : string;
    name : string;
    surname : string;
    taxID : string;
    birthDate : string ;
    address : Address;
    phoneNumber : string;
    driveLicenceNumber : string;
    driveLicenceExpirationDate : string ;
    identityCardNumber : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.taxID = "" ;
                this.birthDate = null;
                this.address = new Address();
                this.phoneNumber = "" ;
                this.driveLicenceNumber = "" ;
                this.driveLicenceExpirationDate = null;
                this.identityCardNumber = "" ;
        }
}

export class CompleteProfileVM {
    email : string;
    name : string;
    surname : string;

    constructor()
    {
    	            this.email = "" ;
                this.name = "" ;
                this.surname = "" ;
        }
}

export class ImpersonatedUserVM extends LoggedUserVM {
    impersonatedCompleteName : string;
    impersonatedRole : string;
    impersonatedIdentifier : string;

    constructor()
    {
    	        super();
		            this.impersonatedCompleteName = "" ;
                this.impersonatedRole = "" ;
                this.impersonatedIdentifier = "" ;
        }
}

export class InternalUserVm {
    identifier : string;
    email : string;
    name : string;
    surname : string;
    phoneNumber : string;
    newPassword : string;
    role : string;
    disabledOn : string ;
    disabledBy : ThumbnailBaseUser;

    constructor()
    {
    	            this.identifier = "" ;
                this.email = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.phoneNumber = "" ;
                this.newPassword = "" ;
                this.role = "" ;
                this.disabledOn = null;
                this.disabledBy = new ThumbnailBaseUser();
        }
}

export class WithLocationUserVM extends InternalUserVm {
    location : TextIdentifier;

    constructor()
    {
    	        super();
		            this.location = new TextIdentifier();
        }
}

export class UserVM extends InternalUserVm {
    documentExpiresOn : string ;
    documentNumber : string;
    licenseExpiresOn : string ;
    licenseNumber : string;
    refusedOn : string ;
    approvedOn : string ;

    constructor()
    {
    	        super();
		            this.documentExpiresOn = null;
                this.documentNumber = "" ;
                this.licenseExpiresOn = null;
                this.licenseNumber = "" ;
                this.refusedOn = null;
                this.approvedOn = null;
        }
}

export class ThumbnailBaseUserVM {
    identifier : string;
    role : string;
    completeName : string;
    thumbnailUrl : string;
    email : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.role = "" ;
                this.completeName = "" ;
                this.thumbnailUrl = "" ;
                this.email = "" ;
        }
}

export class Country {
    name : string;
    alpha2Code : string;
    alpha3Code : string;
    numericCode : string;

    constructor()
    {
    	            this.name = "" ;
                this.alpha2Code = "" ;
                this.alpha3Code = "" ;
                this.numericCode = "" ;
        }
}

export class ExtendedCountry extends Country {
    currencies : Currency[];
    languages : Language[];
    callingCodes : string[];
    countryNameTranslation : CountryTranslation;
    timezones : string[];
    topLevelDomains : string[];
    flagUrl : string;

    constructor()
    {
    	        super();
		            this.currencies = [];
                this.languages = [];
                this.callingCodes = [];
                this.countryNameTranslation = new CountryTranslation();
                this.timezones = [];
                this.topLevelDomains = [];
                this.flagUrl = "" ;
        }
}

export class Currency {
    code : string;
    name : string;
    symbol : string;

    constructor()
    {
    	            this.code = "" ;
                this.name = "" ;
                this.symbol = "" ;
        }
}

export class Language {
    iso639_1 : string;
    iso639_2 : string;
    name : string;
    nativeName : string;

    constructor()
    {
    	            this.iso639_1 = "" ;
                this.iso639_2 = "" ;
                this.name = "" ;
                this.nativeName = "" ;
        }
}

export class CountryTranslation {
    de : string;
    es : string;
    fr : string;
    ja : string;
    it : string;
    br : string;
    pt : string;

    constructor()
    {
    	            this.de = "" ;
                this.es = "" ;
                this.fr = "" ;
                this.ja = "" ;
                this.it = "" ;
                this.br = "" ;
                this.pt = "" ;
        }
}

export class ChangePasswordVM {
    userIdentifier : string;
    oldPassword : string;
    newPassword : string;
    repeatPassword : string;

    constructor()
    {
    	            this.userIdentifier = "" ;
                this.oldPassword = "" ;
                this.newPassword = "" ;
                this.repeatPassword = "" ;
        }
}

export class EntityApproveVm {
    identifier : string;
    attachment : string;
    note : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.attachment = "" ;
                this.note = "" ;
        }
}

export class SetPreferenceVM {
    userIdentifier : string;
    settings : Settings;

    constructor()
    {
    	            this.userIdentifier = "" ;
                this.settings = new Settings();
        }
}

export class UserSummaryVM {
    creditoMaturato : number;
    creditoDisponibile : number;
    totaleViaggi : number;
    hasVehicles : boolean;
    submittedOn : string ;
    approvedOn : string ;
    refusedOn : string ;
    refusedFor : string;

    constructor()
    {
    	            this.creditoMaturato = null ;
                this.creditoDisponibile = null ;
                this.totaleViaggi = null ;
                this.hasVehicles = false ;
                this.submittedOn = null;
                this.approvedOn = null;
                this.refusedOn = null;
                this.refusedFor = "" ;
        }
}

export class ErrorVm {
    exception : string;
    level : string;
    message : string;
    request : string;
    header : string;
    url : string;

    constructor()
    {
    	            this.exception = "" ;
                this.level = "" ;
                this.message = "" ;
                this.request = "" ;
                this.header = "" ;
                this.url = "" ;
        }
}

export class ApiVehicleVM {
    identifier : string;
    modelIdentifier : string;
    brandIdentifier : string;
    ownerIdentifier : string;
    providerName : string;
    ownerName : string;
    modelName : string;
    sippCode : string;
    group : string;
    powerCv : number;
    seats : number;
    fuel : string;
    transmission : string;
    thumbnailUrl : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.modelIdentifier = "" ;
                this.brandIdentifier = "" ;
                this.ownerIdentifier = "" ;
                this.providerName = "" ;
                this.ownerName = "" ;
                this.modelName = "" ;
                this.sippCode = "" ;
                this.group = "" ;
                this.powerCv = null ;
                this.seats = null ;
                this.fuel = "" ;
                this.transmission = "" ;
                this.thumbnailUrl = "" ;
        }
}

export class ApiVehicleDeleteVM {
    identifier : string;

    constructor()
    {
    	            this.identifier = "" ;
        }
}

export class ConfigurationInsuranceItem extends SimpleEntity {
    title : string;
    description : RS24LocalizedEntity;
    price : PriceVariation;
    vehicleCategory : string;
    owner : TextIdentifier;
    vehicle : TextIdentifier;
    apiProviders : string[];
    deposit : number;
    theftCoverage : PriceVariation;
    damageCoverage : PriceVariation;
    secondDriver : boolean;
    sippCode : string;
    groupCode : string;

    constructor()
    {
    	        super();
		            this.title = "" ;
                this.description = new RS24LocalizedEntity();
                this.price = new PriceVariation();
                this.vehicleCategory = "" ;
                this.owner = new TextIdentifier();
                this.vehicle = new TextIdentifier();
                this.apiProviders = [];
                this.deposit = null ;
                this.theftCoverage = new PriceVariation();
                this.damageCoverage = new PriceVariation();
                this.secondDriver = false ;
                this.sippCode = "" ;
                this.groupCode = "" ;
        }
}

export class UpdateInsuranceBaseVm {
    reservationIdentifier : string;
    insuranceIdentifier : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.insuranceIdentifier = "" ;
        }
}

export class UpdateInsuranceVm extends UpdateInsuranceBaseVm {
    insurance : ConfigurationInsuranceItem;
    insuranceDailyPrice : number;

    constructor()
    {
    	        super();
		            this.insurance = new ConfigurationInsuranceItem();
                this.insuranceDailyPrice = null ;
        }
}

export class ConfigurationInsuranceItemSaveVM {
    identifier : string;
    title : string;
    value : RS24LocalizedEntity;
    price : PriceVariation;
    theftCoverage : PriceVariation;
    damageCoverage : PriceVariation;
    deposit : number;
    vehicleCategory : string;
    ownerIdentifier : string;
    vehicleIdentifier : string;
    apiProviders : string[];
    secondDriver : boolean;
    sippCode : string;
    groupCode : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.title = "" ;
                this.value = new RS24LocalizedEntity();
                this.price = new PriceVariation();
                this.theftCoverage = new PriceVariation();
                this.damageCoverage = new PriceVariation();
                this.deposit = null ;
                this.vehicleCategory = "" ;
                this.ownerIdentifier = "" ;
                this.vehicleIdentifier = "" ;
                this.apiProviders = [];
                this.secondDriver = false ;
                this.sippCode = "" ;
                this.groupCode = "" ;
        }
}

export class AreaVM {
    identifier : string;
    title : string;
    name : RS24LocalizedEntity;
    city : RS24LocalizedEntity;
    poiIdentifier : string;
    poiText : string;
    slug : RS24LocalizedEntity;
    ordering : number;

    constructor()
    {
    	            this.identifier = "" ;
                this.title = "" ;
                this.name = new RS24LocalizedEntity();
                this.city = new RS24LocalizedEntity();
                this.poiIdentifier = "" ;
                this.poiText = "" ;
                this.slug = new RS24LocalizedEntity();
                this.ordering = null ;
        }
}

export class LocationVM {
    identifier : string;
    address : Address;
    imagesUrls : string[];
    imageToRemove : string[];
    contact : ContactData;
    description : RS24LocalizedEntity;
    pickupNote : RS24LocalizedEntity;
    title : string;
    openingTime : OpeningTime;
    nightTime : WorkPeriod;
    locationFee : PriceVariation;
    specialClosing : DatePeriod[];
    accessories : SellableAccessoryItem[];
    services : ConfigurationServiceItem[];
    locationManagerUser : ThumbnailBaseUserVM;
    siteSlug : string;
    siteCity : string;
    sitePoiIdentifier : string;
    p2pEnabled : boolean;

    constructor()
    {
    	            this.identifier = "" ;
                this.address = new Address();
                this.imagesUrls = [];
                this.imageToRemove = [];
                this.contact = new ContactData();
                this.description = new RS24LocalizedEntity();
                this.pickupNote = new RS24LocalizedEntity();
                this.title = "" ;
                this.openingTime = new OpeningTime();
                this.nightTime = new WorkPeriod();
                this.locationFee = new PriceVariation();
                this.specialClosing = [];
                this.accessories = [];
                this.services = [];
                this.locationManagerUser = new ThumbnailBaseUserVM();
                this.siteSlug = "" ;
                this.siteCity = "" ;
                this.sitePoiIdentifier = "" ;
                this.p2pEnabled = false ;
        }
}

export class OpeningTime {
    workPeriods : WorkPeriod[];

    constructor()
    {
    	            this.workPeriods = [];
        }
}

export class WorkPeriod {
    dayOfWeek : DayOfWeek;
    open : string;
    close : string;

    constructor()
    {
    	            this.dayOfWeek = null;
                this.open = "" ;
                this.close = "" ;
        }
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class SellableAccessoryItem extends TextIconIdentifier {
    code : string;
    payOnline : boolean;
    price : number;
    singlePrice : number;
    duration : number;
    qty : number;

    constructor()
    {
    	        super();
		            this.code = "" ;
                this.payOnline = false ;
                this.price = null ;
                this.singlePrice = null ;
                this.duration = null ;
                this.qty = null ;
        }
}

export class ConfigurationServiceItem extends SimpleEntity {
    icon : AWSS3Attachment;
    text : RS24LocalizedEntity;

    constructor()
    {
    	        super();
		            this.icon = new AWSS3Attachment();
                this.text = new RS24LocalizedEntity();
        }
}

export class ApiLocationVM extends LocationVM {
    apiStructureID : string;
    providerName : string;
    apiPhoneNumber : string;

    constructor()
    {
    	        super();
		            this.apiStructureID = "" ;
                this.providerName = "" ;
                this.apiPhoneNumber = "" ;
        }
}

export class LocationProfileVM {
    identifier : string;
    imagesUrls : string[];
    title : string;
    address : Address;
    contact : ContactData;
    openingTime : OpeningTime;
    description : RS24LocalizedEntity;
    services : TextImageIdItemVM[];
    accessories : TextImageIdItemVM[];

    constructor()
    {
    	            this.identifier = "" ;
                this.imagesUrls = [];
                this.title = "" ;
                this.address = new Address();
                this.contact = new ContactData();
                this.openingTime = new OpeningTime();
                this.description = new RS24LocalizedEntity();
                this.services = [];
                this.accessories = [];
        }
}

export class ApiLocationListVM extends LocationListVM {
    apiStructureID : string;
    providerName : string;

    constructor()
    {
    	        super();
		            this.apiStructureID = "" ;
                this.providerName = "" ;
        }
}

export class SellableAccessoryItemVM {
    payOnline : boolean;
    price : number;
    identifier : string;
    text : RS24LocalizedEntity;
    publicUrl : string;
    icon : AWSS3Attachment;

    constructor()
    {
    	            this.payOnline = false ;
                this.price = null ;
                this.identifier = "" ;
                this.text = new RS24LocalizedEntity();
                this.publicUrl = "" ;
                this.icon = new AWSS3Attachment();
        }
}

export class ProvinceVM {
    province : string;
    latitude : number;
    longitude : number;
    numberVehicle : number;

    constructor()
    {
    	            this.province = "" ;
                this.latitude = null ;
                this.longitude = null ;
                this.numberVehicle = null ;
        }
}

export class LocationAvailabilityListVM {
    identifier : string;
    address : Address;
    contact : ContactData;
    title : string;
    openingTime : OpeningTime;

    constructor()
    {
    	            this.identifier = "" ;
                this.address = new Address();
                this.contact = new ContactData();
                this.title = "" ;
                this.openingTime = new OpeningTime();
        }
}

export class PoiCitiesCountVM {
    poiName : string;
    poiSlug : string;
    cityLocationsDetails : SiteCitiesLocationDetailsVM[];

    constructor()
    {
    	            this.poiName = "" ;
                this.poiSlug = "" ;
                this.cityLocationsDetails = [];
        }
}

export class SiteCitiesLocationDetailsVM {
    city : string;
    locationsDetails : SiteLocationDetailVM[];

    constructor()
    {
    	            this.city = "" ;
                this.locationsDetails = [];
        }
}

export class SiteLocationDetailVM {
    address : Address;
    imagesUrls : string[];
    contact : ContactData;
    description : string;
    providerName : string;
    title : string;
    openingTime : OpeningTime;
    specialClosing : DatePeriod[];
    cars : SiteCarVm[];
    siteSlug : string;
    siteCity : string;
    sitePoi : string;
    htmlContent : string;
    locationAreaData : LocationAreaDataVM[];
    areaRefIdentifier : string;

    constructor()
    {
    	            this.address = new Address();
                this.imagesUrls = [];
                this.contact = new ContactData();
                this.description = "" ;
                this.providerName = "" ;
                this.title = "" ;
                this.openingTime = new OpeningTime();
                this.specialClosing = [];
                this.cars = [];
                this.siteSlug = "" ;
                this.siteCity = "" ;
                this.sitePoi = "" ;
                this.htmlContent = "" ;
                this.locationAreaData = [];
                this.areaRefIdentifier = "" ;
        }
}

export class SiteCarVm {
    carCategory : string;
    imageUrl : string;
    carModel : string;
    minPrice : number;

    constructor()
    {
    	            this.carCategory = "" ;
                this.imageUrl = "" ;
                this.carModel = "" ;
                this.minPrice = null ;
        }
}

export class LocationAreaDataVM {
    id : string;
    text : string;
    poi : string;
    poiIcon : string;

    constructor()
    {
    	            this.id = "" ;
                this.text = "" ;
                this.poi = "" ;
                this.poiIcon = "" ;
        }
}

export class ReservationSummaryDataVm {
    reservationIdentifier : string;
    reservationNumber : string;
    driverCompleteName : string;
    isApiReservation : boolean;
    vehicle : BaseVehicle;
    period : DatePeriod;
    status : VehicleReservationStatus;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.reservationNumber = "" ;
                this.driverCompleteName = "" ;
                this.isApiReservation = false ;
                this.vehicle = new BaseVehicle();
                this.period = new DatePeriod();
                this.status = null;
        }
}

export enum VehicleReservationStatus {
    Created = 10,
    Confirmed = 15,
    OwnerCheckIn = 20,
    DriverCheckOut = 30,
    DriverCheckIn = 40,
    OwnerCheckOut = 50,
    NoShow = 60,
    Voided = -2,
    Rejected = -1,
}

export class ReservationDetailVm {
    reservationNumber : string;
    summaryData : ReservationSummaryDataVm;
    driver : LocationDriverVM;
    driverCheckoutData : CheckInOutDataVm;
    driverCheckinData : CheckInOutDataVm;
    depositoCauzionale : number;
    notes : Note[];
    insuranceDetail : InsuranceDetailVM;
    accessories : SellableAccessoryItemVM[];
    secondDriver : SecondDriver;

    constructor()
    {
    	            this.reservationNumber = "" ;
                this.summaryData = new ReservationSummaryDataVm();
                this.driver = new LocationDriverVM();
                this.driverCheckoutData = new CheckInOutDataVm();
                this.driverCheckinData = new CheckInOutDataVm();
                this.depositoCauzionale = null ;
                this.notes = [];
                this.insuranceDetail = new InsuranceDetailVM();
                this.accessories = [];
                this.secondDriver = new SecondDriver();
        }
}

export class LocationDriverVM {
    identifier : string;
    completeName : string;
    age : number;
    email : string;
    phoneNumber : string;
    profileCompleted : boolean;

    constructor()
    {
    	            this.identifier = "" ;
                this.completeName = "" ;
                this.age = null ;
                this.email = "" ;
                this.phoneNumber = "" ;
                this.profileCompleted = false ;
        }
}

export class CheckInOutDataVm {
    contrattoStatoVeicoloUrl : string;
    contrattoNoleggioUrl : string;
    distanceKm : number;
    fuelAmount : number;
    note : string;

    constructor()
    {
    	            this.contrattoStatoVeicoloUrl = "" ;
                this.contrattoNoleggioUrl = "" ;
                this.distanceKm = null ;
                this.fuelAmount = null ;
                this.note = "" ;
        }
}

export class Note {
    creator : ThumbnailBaseUser;
    createdOn : string ;
    text : string;
    displayInReservationDetail : boolean;

    constructor()
    {
    	            this.creator = new ThumbnailBaseUser();
                this.createdOn = null;
                this.text = "" ;
                this.displayInReservationDetail = false ;
        }
}

export class InsuranceDetailVM {
    title : string;
    description : string;
    deposit : number;
    franchise : number;
    theftCoverage : number;

    constructor()
    {
    	            this.title = "" ;
                this.description = "" ;
                this.deposit = null ;
                this.franchise = null ;
                this.theftCoverage = null ;
        }
}

export class SecondDriver {
    name : string;
    surname : string;
    dateOfBirth : string ;
    placeOfBirth : string;
    licenseNumber : string;
    licenseExpiresOn : string ;

    constructor()
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.dateOfBirth = null;
                this.placeOfBirth = "" ;
                this.licenseNumber = "" ;
                this.licenseExpiresOn = null;
        }
}

export class CheckInOutVm {
    reservationIdentifier : string;
    checkinImages : string[];
    signatures : string[];
    distanceKm : number;
    fuelAmount : number;
    note : string;
    vehicle : CheckOutVehicleDataVm;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.checkinImages = [];
                this.signatures = [];
                this.distanceKm = null ;
                this.fuelAmount = null ;
                this.note = "" ;
                this.vehicle = new CheckOutVehicleDataVm();
        }
}

export class CheckOutVehicleDataVm {
    licensePlate : string;

    constructor()
    {
    	            this.licensePlate = "" ;
        }
}

export class CustomerForListVm {
    identifier : string;
    thumbnailUrl : string;
    completeName : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.thumbnailUrl = "" ;
                this.completeName = "" ;
        }
}

export class CompleteDriverProfileVM {
    userIdentifier : string;
    backId : UploadImageVM;
    frontId : UploadImageVM;
    frontLicense : UploadImageVM;
    backLicense : UploadImageVM;
    fiscalCode : string;
    phoneNumber : string;
    countryCodeOfResidence : string;

    constructor()
    {
    	            this.userIdentifier = "" ;
                this.backId = new UploadImageVM();
                this.frontId = new UploadImageVM();
                this.frontLicense = new UploadImageVM();
                this.backLicense = new UploadImageVM();
                this.fiscalCode = "" ;
                this.phoneNumber = "" ;
                this.countryCodeOfResidence = "" ;
        }
}

export class UploadImageVM {
    fileData : string;
    fileName : string;

    constructor()
    {
    	            this.fileData = "" ;
                this.fileName = "" ;
        }
}

export class ParkingoAreaVM {
    identifier : string;
    title : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.title = "" ;
        }
}

export class ParkingoAvailabilityResponseVM {
    name : string;
    days : number;
    discount : number;
    totalPrice : number;
    price : number;
    discountAmount : number;
    locationData : LocationDetailVM;

    constructor()
    {
    	            this.name = "" ;
                this.days = null ;
                this.discount = null ;
                this.totalPrice = null ;
                this.price = null ;
                this.discountAmount = null ;
                this.locationData = new LocationDetailVM();
        }
}

export class ParkingoAvailabilityRequestVM {
    locationIdentifier : string;
    datePeriod : DatePeriodVM;
    vehicleIdentifier : string;

    constructor()
    {
    	            this.locationIdentifier = "" ;
                this.datePeriod = new DatePeriodVM();
                this.vehicleIdentifier = "" ;
        }
}

export class ParkingoReservationResponseVM extends ParkingoAvailabilityResponseVM {
    reservationNumber : string;
    checkIn : string ;
    checkOut : string ;

    constructor()
    {
    	        super();
		            this.reservationNumber = "" ;
                this.checkIn = null;
                this.checkOut = null;
        }
}

export class ParkingoReservationRequestVM extends ParkingoAvailabilityRequestVM {
    discount : number;
    price : number;
    totalPrice : number;

    constructor()
    {
    	        super();
		            this.discount = null ;
                this.price = null ;
                this.totalPrice = null ;
        }
}

export class ParkingoCheckInVM {
    reservationNumber : string;
    status : string;

    constructor()
    {
    	            this.reservationNumber = "" ;
                this.status = "" ;
        }
}

export class ParkingoSearchResultVM {
    availabilities : ParkingoCarAvailabilityVM[];
    errorCode : string;

    constructor()
    {
    	            this.availabilities = [];
                this.errorCode = "" ;
        }
}

export class ParkingoCarAvailabilityVM {
    dailyPrice : number;
    discountDailyPrice : number;
    appliedPromotion : string;
    promotionMessage : string;
    discount : number;
    rentPrice : number;
    image : string;
    modelName : string;
    brandName : string;
    category : string;
    link : string;
    locationName : string;

    constructor()
    {
    	            this.dailyPrice = null ;
                this.discountDailyPrice = null ;
                this.appliedPromotion = "" ;
                this.promotionMessage = "" ;
                this.discount = null ;
                this.rentPrice = null ;
                this.image = "" ;
                this.modelName = "" ;
                this.brandName = "" ;
                this.category = "" ;
                this.link = "" ;
                this.locationName = "" ;
        }
}

export class AreaDataVM {
    areaIdentifier : string;
    names : { [key: string]: string; };
    poi : { [key: string]: string; };

    constructor()
    {
    	            this.areaIdentifier = "" ;
                this.names = {};
                this.poi = {};
        }
}

export class ShuttleDemandVM {
    locationName : string;
    startDate : string;
    customerName : string;
    customerEmail : string;
    customerPhone : string;
    service : string;
    vehicleCategory : string;
    vehicleDoors : string;
    vehicleMaxPeople : string;
    locationEmail : string;
    locationPhone : string;
    locationAddress : string;
    voucher : string;

    constructor()
    {
    	            this.locationName = "" ;
                this.startDate = "" ;
                this.customerName = "" ;
                this.customerEmail = "" ;
                this.customerPhone = "" ;
                this.service = "" ;
                this.vehicleCategory = "" ;
                this.vehicleDoors = "" ;
                this.vehicleMaxPeople = "" ;
                this.locationEmail = "" ;
                this.locationPhone = "" ;
                this.locationAddress = "" ;
                this.voucher = "" ;
        }
}

export class ReservationSummaryVM {
    reservationIdentifier : string;
    reservationNumber : string;
    vehicleThumbnailUrl : string;
    vehicleBrand : string;
    vehicleModel : string;
    driverIdentifier : string;
    driverName : string;
    totalDays : number;
    period : DatePeriodVM;
    dailyInsuranceAmount : number;
    totalInsuranceAmount : number;
    totalAmount : number;
    userBalance : number;
    reservationAmount : number;
    totalRentAmount : number;
    dailyRentAmount : number;
    totalAccessoriesAmount : number;
    totalFeeAmount : number;
    originalBasePrice : number;
    accessories : SellableAccessoryItem[];
    priceVariations : BasePriceRule[];
    appliedPriceVariations : BasePriceRule[];
    isApi : boolean;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.reservationNumber = "" ;
                this.vehicleThumbnailUrl = "" ;
                this.vehicleBrand = "" ;
                this.vehicleModel = "" ;
                this.driverIdentifier = "" ;
                this.driverName = "" ;
                this.totalDays = null ;
                this.period = new DatePeriodVM();
                this.dailyInsuranceAmount = null ;
                this.totalInsuranceAmount = null ;
                this.totalAmount = null ;
                this.userBalance = null ;
                this.reservationAmount = null ;
                this.totalRentAmount = null ;
                this.dailyRentAmount = null ;
                this.totalAccessoriesAmount = null ;
                this.totalFeeAmount = null ;
                this.originalBasePrice = null ;
                this.accessories = [];
                this.priceVariations = [];
                this.appliedPriceVariations = [];
                this.isApi = false ;
        }
}

export class ReservationVm {
    reservationIdentifier : string;
    vehicleIdentifier : string;
    locationIdentifier : string;
    fiscalDataIdentifier : string;
    driverIdentifier : string;
    ownerIdentifier : string;
    availabilityIdentifier : string;
    vehicleCategory : string;
    period : DatePeriodVM;
    insurance : ConfigurationInsuranceItem;
    accessories : SellableAccessoryItem[];
    priceDetail : ReservationPriceDetail;
    isApi : boolean;
    vehicleDetailForBooking : VehicleDetailForBooking;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.vehicleIdentifier = "" ;
                this.locationIdentifier = "" ;
                this.fiscalDataIdentifier = "" ;
                this.driverIdentifier = "" ;
                this.ownerIdentifier = "" ;
                this.availabilityIdentifier = "" ;
                this.vehicleCategory = "" ;
                this.period = new DatePeriodVM();
                this.insurance = new ConfigurationInsuranceItem();
                this.accessories = [];
                this.priceDetail = new ReservationPriceDetail();
                this.isApi = false ;
                this.vehicleDetailForBooking = new VehicleDetailForBooking();
        }
}

export class ReservationPriceDetail {
    rentPrice : number;
    dailyPrice : number;
    accessoriesPrice : number;
    insurancePrice : number;
    additionalFee : number;
    totalDays : number;
    originalPeriod : DatePeriod;
    totalAmount : number;
    dailyPackagePrice : number;
    packagePrice : number;

    constructor()
    {
    	            this.rentPrice = null ;
                this.dailyPrice = null ;
                this.accessoriesPrice = null ;
                this.insurancePrice = null ;
                this.additionalFee = null ;
                this.totalDays = null ;
                this.originalPeriod = new DatePeriod();
                this.totalAmount = null ;
                this.dailyPackagePrice = null ;
                this.packagePrice = null ;
        }
}

export class VehicleDetailForBooking {
    vehicle : Vehicle;
    distanceIncluded : string;
    extraPriceForDistance : string;
    location : LocationDetailVM;
    priceForDay : number;

    constructor()
    {
    	            this.vehicle = new Vehicle();
                this.distanceIncluded = "" ;
                this.extraPriceForDistance = "" ;
                this.location = new LocationDetailVM();
                this.priceForDay = null ;
        }
}

export class Vehicle extends SimpleEntity {
    licensePlate : string;
    features : TextIconIdentifier[];
    description : string;
    registrationYear : number;
    reservableStatus : Status;
    images : AWSS3Attachment[];
    imageCoverIndex : number;
    damageEvents : DamageEvent[];
    reservationFeedbacks : ReservationFeedback[];
    model : BaseVehicleModel;
    kmPrice : number;
    includedDistance : number;
    feedback : number;
    fuel : string;
    powerCv : number;
    seats : number;
    thumbnailUrl : string;
    transmission : string;
    useConditions : TextIconIdentifier[];
    minDriverAge : number;
    owner : ThumbnailBaseUser;
    approvedOn : string ;
    submittedOn : string ;
    approvedBy : ThumbnailBaseUser;
    disabledOn : string ;
    createdOn : string ;
    disabledBy : ThumbnailBaseUser;
    baseDailyPrice : number;
    editable : boolean;
    shares : number;
    refusedOn : string ;
    refusedFor : string;
    isProfessional : boolean;

    constructor()
    {
    	        super();
		            this.licensePlate = "" ;
                this.features = [];
                this.description = "" ;
                this.registrationYear = null ;
                this.reservableStatus = new Status();
                this.images = [];
                this.imageCoverIndex = null ;
                this.damageEvents = [];
                this.reservationFeedbacks = [];
                this.model = new BaseVehicleModel();
                this.kmPrice = null ;
                this.includedDistance = null ;
                this.feedback = null ;
                this.fuel = "" ;
                this.powerCv = null ;
                this.seats = null ;
                this.thumbnailUrl = "" ;
                this.transmission = "" ;
                this.useConditions = [];
                this.minDriverAge = null ;
                this.owner = new ThumbnailBaseUser();
                this.approvedOn = null;
                this.submittedOn = null;
                this.approvedBy = new ThumbnailBaseUser();
                this.disabledOn = null;
                this.createdOn = null;
                this.disabledBy = new ThumbnailBaseUser();
                this.baseDailyPrice = null ;
                this.editable = false ;
                this.shares = null ;
                this.refusedOn = null;
                this.refusedFor = "" ;
                this.isProfessional = false ;
        }
}

export class Status {
    statuses : StatusDetail[];
    lastStatus : StatusDetail;

    constructor()
    {
    	            this.statuses = [];
                this.lastStatus = new StatusDetail();
        }
}

export class StatusDetail {
    createdOn : string ;
    createdBy : ThumbnailBaseUser;
    statusEnum : number;
    note : string;

    constructor()
    {
    	            this.createdOn = null;
                this.createdBy = new ThumbnailBaseUser();
                this.statusEnum = null ;
                this.note = "" ;
        }
}

export class DamageEvent {
    damages : VehicleDamage[];
    insertedOn : string ;
    insertedBy : ThumbnailBaseUser;
    location : TextIdentifier;
    reservation : TextIdentifier;

    constructor()
    {
    	            this.damages = [];
                this.insertedOn = null;
                this.insertedBy = new ThumbnailBaseUser();
                this.location = new TextIdentifier();
                this.reservation = new TextIdentifier();
        }
}

export class VehicleDamage {
    image : AWSS3Attachment;
    damagePosition : string;
    damageDescription : string;

    constructor()
    {
    	            this.image = new AWSS3Attachment();
                this.damagePosition = "" ;
                this.damageDescription = "" ;
        }
}

export class Feedback {
    stars : number;
    comment : string;
    postedBy : ThumbnailBaseUser;
    postedOn : string ;

    constructor()
    {
    	            this.stars = null ;
                this.comment = "" ;
                this.postedBy = new ThumbnailBaseUser();
                this.postedOn = null;
        }
}

export class ReservationFeedback extends Feedback {
    reservationNumber : string;

    constructor()
    {
    	        super();
		            this.reservationNumber = "" ;
        }
}

export class UpdateReservationLocationVm {
    reservationIdentifier : string;
    locationIdentifier : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.locationIdentifier = "" ;
        }
}

export class UpdateReservationFiscalDataVm {
    reservationIdentifier : string;
    fiscalDataIdentifier : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.fiscalDataIdentifier = "" ;
        }
}

export class UpdateReservationPeriodVm {
    reservationIdentifier : string;
    period : DatePeriodVM;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.period = new DatePeriodVM();
        }
}

export class UpdateDriverVm {
    reservationIdentifier : string;
    driverIdentifier : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.driverIdentifier = "" ;
        }
}

export class UpdateApiVehicleVm {
    reservationIdentifier : string;
    vehicleIdentifier : string;
    locationIdentifier : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.vehicleIdentifier = "" ;
                this.locationIdentifier = "" ;
        }
}

export class UpdateReservationAvailabilityVm {
    reservationIdentifier : string;
    availabilityIdentifier : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.availabilityIdentifier = "" ;
        }
}

export class UpdateAccessoriesVm {
    reservationIdentifier : string;
    accessories : SellableAccessoryItemVM[];

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.accessories = [];
        }
}

export class BackofficeReservationDetailVM {
    reservationIdentifier : string;
    vehicle : BaseVehicle;
    dailyPrice : SimplePrice;
    priceVariations : BasePriceRule[];
    driver : AgeThumbnailBaseUser;
    driverEmail : string;
    driverLocale : string;
    ownerEmail : string;
    period : DatePeriodVM;
    location : TextIdentifier;
    accessories : SellableAccessoryItem[];
    insurance : ConfigurationInsuranceItem;
    services : AppliedService[];
    gmcFee : number;
    amount : number;
    reservationNumber : string;
    reservationStatus : ReservationStatus;
    checkin : VehicleCheckInOutData;
    checkout : VehicleCheckInOutData;
    checkInContract : string;
    checkOutContract : string;
    originalCheckInContract : string;
    originalCheckOutContract : string;
    previewDocuments : string[];
    newFile : string[];
    imageToRemove : string[];
    disabled : boolean;
    notes : Note[];
    additionalFees : AdditionalFee[];
    distance : DistancePeriod;
    priceDetail : ReservationPriceDetail;
    amountRepartition : PriceRepartitionDetail;
    apiReservationIntegration : ApiReservationIntegration;
    isApiReservation : boolean;
    fiscalData : FiscalDataVM;
    secondDriver : SecondDriver;
    status : number;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.vehicle = new BaseVehicle();
                this.dailyPrice = new SimplePrice();
                this.priceVariations = [];
                this.driver = new AgeThumbnailBaseUser();
                this.driverEmail = "" ;
                this.driverLocale = "" ;
                this.ownerEmail = "" ;
                this.period = new DatePeriodVM();
                this.location = new TextIdentifier();
                this.accessories = [];
                this.insurance = new ConfigurationInsuranceItem();
                this.services = [];
                this.gmcFee = null ;
                this.amount = null ;
                this.reservationNumber = "" ;
                this.reservationStatus = new ReservationStatus();
                this.checkin = new VehicleCheckInOutData();
                this.checkout = new VehicleCheckInOutData();
                this.checkInContract = "" ;
                this.checkOutContract = "" ;
                this.originalCheckInContract = "" ;
                this.originalCheckOutContract = "" ;
                this.previewDocuments = [];
                this.newFile = [];
                this.imageToRemove = [];
                this.disabled = false ;
                this.notes = [];
                this.additionalFees = [];
                this.distance = new DistancePeriod();
                this.priceDetail = new ReservationPriceDetail();
                this.amountRepartition = new PriceRepartitionDetail();
                this.apiReservationIntegration = new ApiReservationIntegration();
                this.isApiReservation = false ;
                this.fiscalData = new FiscalDataVM();
                this.secondDriver = new SecondDriver();
                this.status = null ;
        }
}

export class AgeThumbnailBaseUser extends ThumbnailBaseUser {
    age : number;

    constructor()
    {
    	        super();
		            this.age = null ;
        }
}

export class AppliedService {
    repliedOn : string ;
    customerServiceUser : ThumbnailBaseUser;
    reply : string;
    icon : AWSS3Attachment;
    identifier : string;
    text : RS24LocalizedEntity;

    constructor()
    {
    	            this.repliedOn = null;
                this.customerServiceUser = new ThumbnailBaseUser();
                this.reply = "" ;
                this.icon = new AWSS3Attachment();
                this.identifier = "" ;
                this.text = new RS24LocalizedEntity();
        }
}

export class ReservationStatus extends Status {

    constructor()
    {
    	        super();
		    }
}

export class VehicleCheckInOutData {
    images : AWSS3Attachment[];
    imagesLow : AWSS3Attachment[];
    signatures : AWSS3Attachment[];
    contractPdf : AWSS3Attachment;
    originalContractPdf : AWSS3Attachment;
    photoContractPdf : AWSS3Attachment;
    actualDate : string ;
    distanceKm : number;
    fuelAmount : number;
    note : string;

    constructor()
    {
    	            this.images = [];
                this.imagesLow = [];
                this.signatures = [];
                this.contractPdf = new AWSS3Attachment();
                this.originalContractPdf = new AWSS3Attachment();
                this.photoContractPdf = new AWSS3Attachment();
                this.actualDate = null;
                this.distanceKm = null ;
                this.fuelAmount = null ;
                this.note = "" ;
        }
}

export class AdditionalFee extends PriceTag {
    payedOn : string ;
    transactionNote : string;
    note : string;
    additionalFeeType : string;
    accountStatement : TextIdentifier;

    constructor()
    {
    	        super();
		            this.payedOn = null;
                this.transactionNote = "" ;
                this.note = "" ;
                this.additionalFeeType = "" ;
                this.accountStatement = new TextIdentifier();
        }
}

export class DistancePeriod {
    startKm : number;
    endKm : number;

    constructor()
    {
    	            this.startKm = null ;
                this.endKm = null ;
        }
}

export class PriceRepartitionDetail {
    location : PriceRepartition;
    owner : PriceRepartition;
    gmc : PriceRepartition;
    agency : PriceRepartition;

    constructor()
    {
    	            this.location = new PriceRepartition();
                this.owner = new PriceRepartition();
                this.gmc = new PriceRepartition();
                this.agency = new PriceRepartition();
        }
}

export class PriceRepartition {
    percentage : number;
    amount : number;

    constructor()
    {
    	            this.percentage = null ;
                this.amount = null ;
        }
}

export class ApiReservationIntegration {
    apiProviderName : string;
    apiProviderReservationNumber : string;
    sippCode : string;
    groupCode : string;
    apiReservationStatus : string;
    token : string;
    driverDataSent : boolean;
    depositInfo : DepositData;
    providerData : ProviderReservationData;

    constructor()
    {
    	            this.apiProviderName = "" ;
                this.apiProviderReservationNumber = "" ;
                this.sippCode = "" ;
                this.groupCode = "" ;
                this.apiReservationStatus = "" ;
                this.token = "" ;
                this.driverDataSent = false ;
                this.depositInfo = new DepositData();
                this.providerData = new ProviderReservationData();
        }
}

export class DepositData {
    emailSent : boolean;
    smsSent : boolean;
    amount : number;
    depositLink : string;
    phoneNumber : string;
    device : string;
    depositDone : boolean;

    constructor()
    {
    	            this.emailSent = false ;
                this.smsSent = false ;
                this.amount = null ;
                this.depositLink = "" ;
                this.phoneNumber = "" ;
                this.device = "" ;
                this.depositDone = false ;
        }
}

export class ProviderReservationData {
    vehicle : ApiProviderVehicleData;

    constructor()
    {
    	            this.vehicle = new ApiProviderVehicleData();
        }
}

export class VoidReservationVm {
    reservationId : string;
    note : string;

    constructor()
    {
    	            this.reservationId = "" ;
                this.note = "" ;
        }
}

export class PagedResponseOfReservationListVM {
    items : ReservationListVM[];
    totalItemsCount : number;

    constructor()
    {
    	            this.items = [];
                this.totalItemsCount = null ;
        }
}

export class ReservationListBM {
    identifier : string;
    locationName : string;
    driverName : string;
    ownerName : string;
    channel : string;
    promoterName : string;
    vehicleDetail : string;
    modifiedOn : string ;
    confirmedOn : string ;
    checkIn : string ;
    checkOut : string ;
    status : StatusDetail;
    statusDescr : string;
    code : string;
    checkInContract : string;
    checkOutContract : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.locationName = "" ;
                this.driverName = "" ;
                this.ownerName = "" ;
                this.channel = "" ;
                this.promoterName = "" ;
                this.vehicleDetail = "" ;
                this.modifiedOn = null;
                this.confirmedOn = null;
                this.checkIn = null;
                this.checkOut = null;
                this.status = new StatusDetail();
                this.statusDescr = "" ;
                this.code = "" ;
                this.checkInContract = "" ;
                this.checkOutContract = "" ;
        }
}

export class ReservationListVM extends ReservationListBM {

    constructor()
    {
    	        super();
		    }
}

export class DetailReservationForCustomer {
    reservationIdentifier : string;
    reservationNumber : string;
    otherPerson : ThumbnailBaseUser;
    vehicle : BaseVehicle;
    location : TextIdentifier;
    period : DatePeriod;
    status : number;
    isDriver : boolean;
    isRequest : boolean;
    driverCheckoutData : CheckInOutDataVm;
    driverCheckinData : CheckInOutDataVm;
    notes : Note[];
    secondDriver : SecondDriver;
    amount : number;
    ownerAmount : number;
    grossAmountForOwner : number;
    ownerAmountPerDay : number;
    amountPerDay : number;
    carPerDay : number;
    carTotal : number;
    insurancePerDay : number;
    insuranceTotal : number;
    accessoryPerDay : number;
    accessoryTotal : number;
    additionalFee : number;
    insuranceSecondDriver : boolean;
    insuranceDetail : InsuranceDetailVM;
    accessories : SellableAccessoryItemVM[];
    isApi : boolean;
    fiscalData : FiscalData;
    totalDays : number;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.reservationNumber = "" ;
                this.otherPerson = new ThumbnailBaseUser();
                this.vehicle = new BaseVehicle();
                this.location = new TextIdentifier();
                this.period = new DatePeriod();
                this.status = null ;
                this.isDriver = false ;
                this.isRequest = false ;
                this.driverCheckoutData = new CheckInOutDataVm();
                this.driverCheckinData = new CheckInOutDataVm();
                this.notes = [];
                this.secondDriver = new SecondDriver();
                this.amount = null ;
                this.ownerAmount = null ;
                this.grossAmountForOwner = null ;
                this.ownerAmountPerDay = null ;
                this.amountPerDay = null ;
                this.carPerDay = null ;
                this.carTotal = null ;
                this.insurancePerDay = null ;
                this.insuranceTotal = null ;
                this.accessoryPerDay = null ;
                this.accessoryTotal = null ;
                this.additionalFee = null ;
                this.insuranceSecondDriver = false ;
                this.insuranceDetail = new InsuranceDetailVM();
                this.accessories = [];
                this.isApi = false ;
                this.fiscalData = new FiscalData();
                this.totalDays = null ;
        }
}

export class VehicleReservation extends BaseEntity {
    vehicle : BaseVehicle;
    dailyPrice : SimplePrice;
    priceVariations : BasePriceRule[];
    appliedPromotions : PromotionData[];
    driver : AgeThumbnailBaseUser;
    secondDriver : SecondDriver;
    period : DatePeriod;
    location : TextIdentifier;
    dropOffLocation : TextIdentifier;
    locationManager : TextIdentifier;
    accessories : SellableAccessoryItem[];
    insurance : ConfigurationInsuranceItem;
    services : AppliedService[];
    images : AWSS3Attachment[];
    fiscalData : FiscalData;
    invoiceData : InvoiceData;
    gmcFee : number;
    reservationNumber : string;
    apiReservationIntegration : ApiReservationIntegration;
    reservationStatus : ReservationStatus;
    checkin : VehicleCheckInOutData;
    checkout : VehicleCheckInOutData;
    disabled : boolean;
    notes : Note[];
    additionalFees : AdditionalFee[];
    accountStatements : TextIdentifier[];
    distance : DistancePeriod;
    priceDetail : ReservationPriceDetail;
    amountRepartition : PriceRepartitionDetail;
    parkingoReservationID : string;
    replacedBy : ReplacedReservationDetail;
    replace : ReplacedReservationDetail;
    channel : string;
    availabilityIdentifier : string;
    agencyData : AgencyReference;
    infoData : AdditionalReservationInfo;
    reservationType : ReservationType;

    constructor()
    {
    	        super();
		            this.vehicle = new BaseVehicle();
                this.dailyPrice = new SimplePrice();
                this.priceVariations = [];
                this.appliedPromotions = [];
                this.driver = new AgeThumbnailBaseUser();
                this.secondDriver = new SecondDriver();
                this.period = new DatePeriod();
                this.location = new TextIdentifier();
                this.dropOffLocation = new TextIdentifier();
                this.locationManager = new TextIdentifier();
                this.accessories = [];
                this.insurance = new ConfigurationInsuranceItem();
                this.services = [];
                this.images = [];
                this.fiscalData = new FiscalData();
                this.invoiceData = new InvoiceData();
                this.gmcFee = null ;
                this.reservationNumber = "" ;
                this.apiReservationIntegration = new ApiReservationIntegration();
                this.reservationStatus = new ReservationStatus();
                this.checkin = new VehicleCheckInOutData();
                this.checkout = new VehicleCheckInOutData();
                this.disabled = false ;
                this.notes = [];
                this.additionalFees = [];
                this.accountStatements = [];
                this.distance = new DistancePeriod();
                this.priceDetail = new ReservationPriceDetail();
                this.amountRepartition = new PriceRepartitionDetail();
                this.parkingoReservationID = "" ;
                this.replacedBy = new ReplacedReservationDetail();
                this.replace = new ReplacedReservationDetail();
                this.channel = "" ;
                this.availabilityIdentifier = "" ;
                this.agencyData = new AgencyReference();
                this.infoData = new AdditionalReservationInfo();
                this.reservationType = new ReservationType();
        }
}

export class PromotionData {
    discount : number;
    promotionChannel : string;
    promoCode : string;
    includedInApi : boolean;
    target : string;
    providerName : string;
    startingFrom : string ;
    bookability : string ;
    validity : string ;
    insurance : InsuranceData;

    constructor()
    {
    	            this.discount = null ;
                this.promotionChannel = "" ;
                this.promoCode = "" ;
                this.includedInApi = false ;
                this.target = "" ;
                this.providerName = "" ;
                this.startingFrom = null;
                this.bookability = null;
                this.validity = null;
                this.insurance = new InsuranceData();
        }
}

export class InsuranceData {
    depositPromo : number;

    constructor()
    {
    	            this.depositPromo = null ;
        }
}

export class InvoiceData {
    createdOn : string ;
    lastInvoice : TextIdentifier;

    constructor()
    {
    	            this.createdOn = null;
                this.lastInvoice = new TextIdentifier();
        }
}

export class ReplacedReservationDetail {
    reservation : TextIdentifier;
    reservationNumber : string;

    constructor()
    {
    	            this.reservation = new TextIdentifier();
                this.reservationNumber = "" ;
        }
}

export class AgencyReference {
    agent : TextIdentifier;
    agency : TextIdentifier;
    promotion : PromotionData;

    constructor()
    {
    	            this.agent = new TextIdentifier();
                this.agency = new TextIdentifier();
                this.promotion = new PromotionData();
        }
}

export class AdditionalReservationInfo {
    flightNumber : string;

    constructor()
    {
    	            this.flightNumber = "" ;
        }
}

export class ReservationType {
    package : boolean;

    constructor()
    {
    	            this.package = false ;
        }
}

export class CreateCustomReservationVm {
    reservationNumber : string;
    driverIdentifier : string;
    vehicleIdentifier : string;
    period : DatePeriod;
    locationIdentifier : string;
    dailyPrice : number;
    insuranceIdentifier : string;

    constructor()
    {
    	            this.reservationNumber = "" ;
                this.driverIdentifier = "" ;
                this.vehicleIdentifier = "" ;
                this.period = new DatePeriod();
                this.locationIdentifier = "" ;
                this.dailyPrice = null ;
                this.insuranceIdentifier = "" ;
        }
}

export class NoteVM {
    note : string;
    backenderIdentifier : string;
    reservationIdentifier : string;
    displayToUser : boolean;

    constructor()
    {
    	            this.note = "" ;
                this.backenderIdentifier = "" ;
                this.reservationIdentifier = "" ;
                this.displayToUser = false ;
        }
}

export class AdditionalFeeVM {
    reservationIdentifier : string;
    identifier : string;
    note : string;
    additionalFeeType : string;
    priceVariation : PriceVariation;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.identifier = "" ;
                this.note = "" ;
                this.additionalFeeType = "" ;
                this.priceVariation = new PriceVariation();
        }
}

export class PayAdditionalFee {
    reservationIdentifier : string;
    feeIndex : number;
    note : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.feeIndex = null ;
                this.note = "" ;
        }
}

export class PriceVariationVM {
    reservationIdentifier : string;
    note : string;
    priceVariation : PriceVariation;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.note = "" ;
                this.priceVariation = new PriceVariation();
        }
}

export class ChangeVehicleVM {
    reservationIdentifier : string;
    ownerIdentifier : string;
    vehicleIdentifier : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.ownerIdentifier = "" ;
                this.vehicleIdentifier = "" ;
        }
}

export class SecondDriverVM {
    reservationIdentifier : string;
    secondDriver : SecondDriver;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.secondDriver = new SecondDriver();
        }
}

export class CopyContractFromReservationVm {
    sourceReservationIdentifier : string;
    sourceReservationNumber : string;
    destinationReservationIdentifier : string;
    destinationReservationNumber : string;

    constructor()
    {
    	            this.sourceReservationIdentifier = "" ;
                this.sourceReservationNumber = "" ;
                this.destinationReservationIdentifier = "" ;
                this.destinationReservationNumber = "" ;
        }
}

export class ContractPhotoVM {
    reservationIdentifier : string;
    checkInPhoto : string[];
    checkOutPhoto : string[];

    constructor()
    {
    	            this.reservationIdentifier = "" ;
                this.checkInPhoto = [];
                this.checkOutPhoto = [];
        }
}

export class StripeIntentResponseVM {
    intentId : string;
    intentSecret : string;
    customerId : string;

    constructor()
    {
    	            this.intentId = "" ;
                this.intentSecret = "" ;
                this.customerId = "" ;
        }
}

export class StripePaymentRequestVM {
    reservationIdentifier : string;

    constructor()
    {
    	            this.reservationIdentifier = "" ;
        }
}

export class StripePaymentMobilityCardVM {
    cardIdentifier : string;
    amount : number;
    bonusAmount : number;

    constructor()
    {
    	            this.cardIdentifier = "" ;
                this.amount = null ;
                this.bonusAmount = null ;
        }
}

export class StripeCustomerVM {
    identifier : string;
    completeName : string;
    email : string;
    paymentMethodId : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.completeName = "" ;
                this.email = "" ;
                this.paymentMethodId = "" ;
        }
}

export class StripeCustomerCardVM {
    paymentMethodId : string;
    customerId : string;

    constructor()
    {
    	            this.paymentMethodId = "" ;
                this.customerId = "" ;
        }
}

export class StripeCardDetailVM {
    cardId : string;
    brand : string;
    country : string;
    currency : string;
    expMonth : number;
    expYear : number;
    dynamicLast4 : string;
    last4 : string;
    holder : string;

    constructor()
    {
    	            this.cardId = "" ;
                this.brand = "" ;
                this.country = "" ;
                this.currency = "" ;
                this.expMonth = null ;
                this.expYear = null ;
                this.dynamicLast4 = "" ;
                this.last4 = "" ;
                this.holder = "" ;
        }
}

export class GeneratePdfVM {
    html : string;

    constructor()
    {
    	            this.html = "" ;
        }
}

export class LicenseVM {
    licenseFileName : string;
    publicUrl : string;

    constructor()
    {
    	            this.licenseFileName = "" ;
                this.publicUrl = "" ;
        }
}

export class BrandListVM {
    brandName : string;
    brandIdentifier : string;
    disabledOn : string ;

    constructor()
    {
    	            this.brandName = "" ;
                this.brandIdentifier = "" ;
                this.disabledOn = null;
        }
}

export class ModelListVM {
    brandIdentifier : string;
    modelIdentifier : string;
    brandName : string;
    modelName : string;
    modelYear : string;
    vehicleCategory : string;
    disabledOn : string ;

    constructor()
    {
    	            this.brandIdentifier = "" ;
                this.modelIdentifier = "" ;
                this.brandName = "" ;
                this.modelName = "" ;
                this.modelYear = "" ;
                this.vehicleCategory = "" ;
                this.disabledOn = null;
        }
}

export class BaseVehicleDetailVm {
    vehicleIdentifier : string;
    model : string;
    brand : string;
    images : string[];
    description : string;
    completeName : string;
    features : ConfigurationVehicleFeatureVM[];
    useConditions : ConfigurationVehicleUseConditionVM[];
    minDriverAge : number;
    category : string;
    plate : string;
    seats : number;
    transmission : string;
    fuel : string;
    powerCv : number;
    isApi : boolean;
    approvedOn : string ;
    refusedOn : string ;

    constructor()
    {
    	            this.vehicleIdentifier = "" ;
                this.model = "" ;
                this.brand = "" ;
                this.images = [];
                this.description = "" ;
                this.completeName = "" ;
                this.features = [];
                this.useConditions = [];
                this.minDriverAge = null ;
                this.category = "" ;
                this.plate = "" ;
                this.seats = null ;
                this.transmission = "" ;
                this.fuel = "" ;
                this.powerCv = null ;
                this.isApi = false ;
                this.approvedOn = null;
                this.refusedOn = null;
        }
}

export class VehicleDetailVm extends BaseVehicleDetailVm {
    ownerIdentifier : string;
    ownerName : string;
    ownerThumbnail : string;
    location : TextThumbnailIdentifier;
    rating : number;
    shares : number;
    dailyPrice : number;
    includedDistance : number;
    pricePerExtraKm : number;
    feedbacks : ReservationFeedback[];
    statusDetailList : StatusDetail[];

    constructor()
    {
    	        super();
		            this.ownerIdentifier = "" ;
                this.ownerName = "" ;
                this.ownerThumbnail = "" ;
                this.location = new TextThumbnailIdentifier();
                this.rating = null ;
                this.shares = null ;
                this.dailyPrice = null ;
                this.includedDistance = null ;
                this.pricePerExtraKm = null ;
                this.feedbacks = [];
                this.statusDetailList = [];
        }
}

export class TextThumbnailIdentifier {
    text : string;
    identifier : string;
    thumbnailUrl : string;

    constructor()
    {
    	            this.text = "" ;
                this.identifier = "" ;
                this.thumbnailUrl = "" ;
        }
}

export class ConfigurationVehicleFeatureVM extends ConfigurationAccessoryItemVM {

    constructor()
    {
    	        super();
		    }
}

export class ConfigurationVehicleUseConditionVM extends ConfigurationAccessoryItemVM {

    constructor()
    {
    	        super();
		    }
}

export class SearchVehicleVm {
    vehicleIdentifier : string;
    period : DatePeriodVM;
    locationIdentifier : string;
    availabilityIdentifier : string;

    constructor()
    {
    	            this.vehicleIdentifier = "" ;
                this.period = new DatePeriodVM();
                this.locationIdentifier = "" ;
                this.availabilityIdentifier = "" ;
        }
}

export class VehicleSaveVM {
    ownerIdentifier : string;
    vehicleIdentifier : string;
    modelIdentifier : string;
    brandIdentifier : string;
    plate : string;
    seats : number;
    fuel : string;
    powerCv : number;
    transmission : string;
    features : string[];
    useConditions : string[];
    minDriverAge : number;
    completeName : string;
    description : string;
    fileIdentifierToRemove : string[];
    imagesList : string[];
    isProfessional : boolean;

    constructor()
    {
    	            this.ownerIdentifier = "" ;
                this.vehicleIdentifier = "" ;
                this.modelIdentifier = "" ;
                this.brandIdentifier = "" ;
                this.plate = "" ;
                this.seats = null ;
                this.fuel = "" ;
                this.powerCv = null ;
                this.transmission = "" ;
                this.features = [];
                this.useConditions = [];
                this.minDriverAge = null ;
                this.completeName = "" ;
                this.description = "" ;
                this.fileIdentifierToRemove = [];
                this.imagesList = [];
                this.isProfessional = false ;
        }
}

export class OwnCarSelectedVM {
    vehicleIdentifier : string;
    vehicleBrand : string;
    vehicleModel : string;
    vehiclePlate : string;
    approvedOn : string ;
    refusedOn : string ;
    refusedFor : string;

    constructor()
    {
    	            this.vehicleIdentifier = "" ;
                this.vehicleBrand = "" ;
                this.vehicleModel = "" ;
                this.vehiclePlate = "" ;
                this.approvedOn = null;
                this.refusedOn = null;
                this.refusedFor = "" ;
        }
}

export class VehicleImageVM {
    publicUrl : string;
    isCover : boolean;

    constructor()
    {
    	            this.publicUrl = "" ;
                this.isCover = false ;
        }
}

export class UpdateImagesVM {
    itemIdentifier : string;
    images : VehicleImageVM[];
    imagesToRemove : string[];
    imagesToUpload : VehicleImageVM[];
    coverIndex : number;

    constructor()
    {
    	            this.itemIdentifier = "" ;
                this.images = [];
                this.imagesToRemove = [];
                this.imagesToUpload = [];
                this.coverIndex = null ;
        }
}

export class VechicleStatusVM {
    vehicleGenericData : VehicleListVM;

    constructor()
    {
    	            this.vehicleGenericData = new VehicleListVM();
        }
}

export class ChangeReservableStatusVm {
    identifier : string;
    note : string;
    isReservable : boolean;

    constructor()
    {
    	            this.identifier = "" ;
                this.note = "" ;
                this.isReservable = false ;
        }
}

export class VehicleFeedbackVM {
    totalFeedback : number;
    totalShares : number;
    averageFeedback : number;
    feedbacks : ReservationFeedback[];

    constructor()
    {
    	            this.totalFeedback = null ;
                this.totalShares = null ;
                this.averageFeedback = null ;
                this.feedbacks = [];
        }
}

export class WithdrawRequest extends SimpleEntity {
    amount : number;
    user : BaseUser;
    note : string;
    createdOn : string ;
    attachment : AWSS3Attachment;
    approvedOn : string ;
    refusedOn : string ;
    refusedFor : string;
    approvedBy : ThumbnailBaseUser;
    iban : string;
    submittedOn : string ;

    constructor()
    {
    	        super();
		            this.amount = null ;
                this.user = new BaseUser();
                this.note = "" ;
                this.createdOn = null;
                this.attachment = new AWSS3Attachment();
                this.approvedOn = null;
                this.refusedOn = null;
                this.refusedFor = "" ;
                this.approvedBy = new ThumbnailBaseUser();
                this.iban = "" ;
                this.submittedOn = null;
        }
}

export class BaseUser {
    identifier : string;
    role : string;
    completeName : string;

    constructor()
    {
    	            this.identifier = "" ;
                this.role = "" ;
                this.completeName = "" ;
        }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class PagedRequestVM {
    paging: PagingFilter;
    sortBy: SortByParameter;
    filter: { [key: string]: string[] };

    constructor() {
        this.paging = new PagingFilter();
        this.sortBy = null;
        this.filter = {};
    }
}

export class ReservationPagedRequestVM extends PagedRequestVM {
    showCreated: boolean;

    constructor() {
        super();
        this.showCreated = false;
    }
}

export class PriceRulePagedRequestVM extends PagedRequestVM {
    showAllRules : boolean;

    constructor()
    {
                super();
                    this.showAllRules = false ;
        }
}

export class PagingFilter {
    currentPage: number;
    itemsPerPage: number;
    skip: number;
    take: number;

    constructor() {
        this.currentPage = 1;
        this.itemsPerPage = 10;
        this.skip = 0;
        this.take = 0;
    }
}

export class SortByParameter {
    propertyName: string;
    ascending: boolean;

    constructor() {
        this.propertyName = "";
        this.ascending = false;
    }
}